export default {
    client_contract: [
        {
            key: "contract_info",
            title: "contract info",
            active: true,
            link: "/v2/contract-client/{id}"
        },
        {
            key: "service_category",
            title: "service category",
            active: false,
            link: "/v2/contract-client/{id}/service-category"
        },
        
        {
            key: "sla",
            title: "SLA",
            active: false,
            link: "/v2/contract-client/{id}/sla"
        },
        {
            key: "properties",
            title: "Properties",
            active: false,
            link: "/v2/contract-client/{id}/properties"

        },
        {
            key: "equipment",
            title: "equipment",
            active: false,
            link: "/v2/contract-client/{id}/equipment"
        },
        {
            key: "sor",
            title: "SOR",
            active: false,
            link: "/v2/contract-client/{id}/sor"
        },
        {
            key: "maintainence_program",
            title: "maintenance Program",
            active: false,
            link: "/v2/contract-client/{id}/maintenance-program",
        },
        {
            key: "fm_officers",
            title: "FM officers",
            active: false,
            link: "/v2/contract-client/{id}/fm-officers",
        },
        {
            key: "client_staff",
            title: "client staff",
            active: false,
            link: "/v2/contract-client/{id}/client-staff",
        },
        {
            key: "checklist_temp",
            title: "checklist temp",
            active: false,
            link: "/v2/contract-client/{id}/checklist-template",
        },
        {
            key: "approval",
            title: "approval",
            active: false,
            link: "/v2/contract-client/{id}/approval",

        },
        {
            key: "finance",
            title: "Finance",
            active: false,
            link: "/v2/contract-client/{id}/fm-codes",
        },
        {
            key: "settings",
            title: "Setting",
            active: false,
            link: "/v2/contract-client/{id}/settings",
        },
        {
            key: "report-config",
            title: "Report Config",
            active: false,
            link: "/v2/contract-client/{id}/report-config",
        },
        {
            key: "config-notification",
            title: "Notification",
            active: false,
            link: "/v2/contract-client/{id}/config-notification",
        },
        {
            key: "case-settings",
            title: "Case Settings",
            active: false,
            link: "/v2/contract-client/{id}/case-settings",
        },
        {
            key: "email_settings",
            title: "email settings",
            active: false,
            link: "/v2/contract-client/{id}/email-settings"
        },
        {
            key: "operating-hours",
            title: "Operating hours",
            active: false,
            link: "/v2/contract-client/{id}/operating-hours",
        },
        {
            key: "maintenance-settings",
            title: "Maintenance settings",
            active: false,
            link: "/v2/contract-client/{id}/maintenance-settings",
        }
    ],
    supplier_contract: [
        {
            key: "contract_info",
            title: "contract info",
            active: true,
            link: "/v2/contract-supplier/{id}"
        },
        {
            key: "service_category",
            title: "service category",
            active: false,
            link: "/v2/contract-supplier/{id}/service-category"
        },
        {
            key: "properties",
            title: "Properties",
            active: false,
            link: "/v2/contract-supplier/{id}/properties"

        },
        {
            key: "equipment",
            title: "equipment",
            active: false,
            link: "/v2/contract-supplier/{id}/equipment"
        },
        {
            key: "sor",
            title: "SOR",
            active: false,
            link: "/v2/contract-supplier/{id}/sor"
        },
        {
            key: "maintainence_program",
            title: "maintenance Program",
            active: false,
            link: "/v2/contract-supplier/{id}/maintenance-program",
        },
        {
            key: "supplier_staff",
            title: "Supplier Staff",
            active: false,
            link: "/v2/contract-supplier/{id}/supplier-staff",
        },
        {
            key: "finance",
            title: "Finance",
            active: false,
            link: "/v2/contract-supplier/{id}/finance",
        },
        // {
        //     key: "approval",
        //     title: "Approval",
        //     active: false,
        //     link: "/v2/contract-supplier/{id}/approval",
        // },
        {
            key: "suppliers",
            title: "Suppliers",
            active: false,
            link: "/v2/contract-supplier/{id}/suppliers",
        },
    ],
    order: [
        {
            key: "main_info",
            title: "Main Info",
            active: true,
            //link: "/v2/contract-client/{id}"
        },
        {
            key: "kpi_target",
            title: "KPI Target",
            active: false,
            //link: "/v2/contract-client/{id}/service-category"
        },
        {
            key: "service_report",
            title: "Service Report",
            active: false,
            //link: "/v2/contract-client/{id}/sla"
        },
        {
            key: "related_work_items",
            title: "Related Work Items",
            active: false,
            //link: "/v2/contract-client/{id}/properties"
        },
        {
            key: "delivery_log",
            title: "Delivery Log",
            active: false,
            //link: "/v2/contract-client/{id}/equipment"
        },
        {
            key: "budget",
            title: "Budget",
            active: false,
            //link: "/v2/contract-client/{id}/sor"
        },
        {
            key: "activity_log",
            title: "Activity Log",
            active: false,
            //link: "/v2/contract-client/{id}/maintenance-program",
        }
    ],
    performance_assesment: [
        {
            key: "contract_sum",
            title: "Contract Sum",
            active: true,
        },
        {
            key: "maintenance_type_weightage",
            title: "Maintenance Type Weightage",
            active: false,
        },
        {
            key: "other_sources_weightage",
            title: "Other Sources Weightage",
            active: false,
        },
        {
            key: "performance_computation",
            title: "Performance Computation",
            active: false,
        },
        {
            key: "rates_of_deduction",
            title: "Rates of Deduction",
            active: false,
        },
        {
            key: "lump_sum_payment",
            title: "Lump Sum Payment",
            active: false,
        },
    ],
    performance_assesment_report: [
        {
            key: "po-inspection",
            title: "PO Inspection",
            active: false,
        },
        {
            key: "maintenance",
            title: "Maintenance",
            active: true,
        },
        {
            key: "other-sources",
            title: "Other Sources",
            active: false,
        },
        {
            key: "interim-report-per-location",
            title: "Consolidated Report Per Division",
            active: false,
        },
        // {
        //     key: "interim-report",
        //     title: "Consolidated Report All Division",
        //     active: false,
        // },
        {
            key: "final-report",
            title: "Final Report",
            active: false,
        },
        {
            key: "rates-of-deduction",
            title: "Rates of Deduction",
            active: false,
        },
    ],
    performance_assesment_data_entries: [
        {
            key: "po",
            title: "Data Entry (PO)",
            active: true,
            link: `/v2/performance-assessment/data-entry-po`
        },
        {
            key: "maintenance-regime",
            title: "Data Entry (Maintenance)",
            active: false,
            link: `/v2/performance-assessment/data-entry-maintenance-regime`
        },
        {
            key: "other-source",
            title: "Data Entry (Other Sources)",
            active: false,
            link: `/v2/performance-assessment/data-entry-other-sources`
        },
        {
            key: "rates-of-deduction",
            title: "Data Entry (Rates of Deduction)",
            active: false,
            link: `/v2/performance-assessment/data-entry-rates-of-deduction`
        },
    ],
    tenants: [
        {
            key: "tenant-site",
            title: "Tenant Site",
            active: true,
            link: `/v2/tenant-site`
        },
        {
            key: "contact-site",
            title: "Contact Site",
            active: false,
            link: `/v2/contact-site`
        }
    ],
    safety_projects: [
        {
            key: "contract_info",
            title: "project info",
            active: true,
            link: "/v2/safety-app-project/{id}"
        },
        {
            key: "service_category",
            title: "service category",
            active: false,
            link: "/v2/safety-app-project/{id}/service-category"
        },
        {
            key: "properties",
            title: "Properties",
            active: false,
            link: "/v2/safety-app-project/{id}/properties"

        },
        // {
        //     key: "equipment",
        //     title: "equipment",
        //     active: false,
        //     link: "/v2/safety-app-project/{id}/equipment"
        // },
        {
            key: "supplier_staff",
            title: "Supplier Staff",
            active: false,
            link: "/v2/safety-app-project/{id}/supplier-staff",
        },
        {
            key: "suppliers",
            title: "Suppliers",
            active: false,
            link: "/v2/safety-app-project/{id}/suppliers",
        },
    ],
}
